/** Types */
export const GET_USERS = "GET_USERS";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const ADD_USERS = "ADD_USERS";
export const EDIT_USERS = "EDIT_USERS";
export const DELETE_USERS = "DELETE_USERS";
export const CHANGE_STATUS_USERS = 'CHANGE_STATUS_USERS'
